export default {
  background_image: 'Achtergrondafbeelding',
};
